import React from "react";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { IShardClusterListItem } from "api/entities/shard-cluster";
import { bucketService } from "api/services/bucket-service";
import { catchException, commonActions } from "../../../redux/actions/common";
import { storagePoolActions } from "../../../redux/actions/shard-cluster";
import { IAppState } from "../../../redux/reducers";
import { useNavigate } from "react-router-dom";
import { routeUtils } from "../../../utils/route-utils";
import MoreOptions from "../../shared-ui/more-options";
import { IPopupMenuOption } from "../../shared-ui/popup-menu";
import { IDeleteBlockedConfirmationDataV2 } from "../dialogs/delete-blocked-confirmation/delete-blocked-confirmation";


const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    openDeleteConfirmation: (storagePool: IShardClusterListItem) =>
      dispatch(storagePoolActions.deleteConfirmation.open(storagePool)),
    openDeleteBlockedConfirmation: (deleteBlockedData: IDeleteBlockedConfirmationDataV2) =>
      dispatch(storagePoolActions.deleteBlockedConfirmation.open(deleteBlockedData)),
    startLoading: () =>
      dispatch(commonActions.startLoading()),
    stopLoading: () =>
      dispatch(commonActions.stopLoading())
  };
};

export interface IMoreOptionProps
  extends ReturnType<typeof mapDispatchToProps> {
  data: IShardClusterListItem;
}

export const MoreOption = connect(null, mapDispatchToProps)((props: IMoreOptionProps) => {
  const navigate = useNavigate();

  function openDeleteConfirmation() {
    props.startLoading();

    bucketService.getPage({ pool: String(props.data.id)}).then(page => {
      if (page.count > 0) {
        props.openDeleteBlockedConfirmation({ buckets: page.data.map(x => ({ id: x.id, name: x.name })), storagePool: props.data });
      }
      else {
        props.openDeleteConfirmation(props.data as IShardClusterListItem);
      }
    }).catch(catchException()).finally(props.stopLoading);
  }

  function getOptions() {
    const options: IPopupMenuOption[] = [
      {
        label: "Manage",
        onClick: () => {
          navigate(routeUtils.getRouteToShardClusterDetails(props.data.id));
        },
      },
      {
        label: "Delete",
        onClick: openDeleteConfirmation
      },
    ];

    return options;
  }

  return (
    <MoreOptions
      options={getOptions()}
    />
  );
});
